module.exports = __webpack_public_path__ + "static/media/source-code.36b98c8b.svg";